import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    class: _vm.$vuetify.breakpoint.xsOnly ? 'pa-2' : 'pa-6',
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    attrs: {
      "justify": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('h3', {
    staticClass: "mt-0 pt-0",
    staticStyle: {
      "margin-bottom": "34px"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.selection')))]), _vm._l(_vm.sidebarItems, function (dtwin, sidebarIndex) {
    return _c('span', {
      key: sidebarIndex
    }, [!_vm.$vuetify.breakpoint.xsOnly || dtwin.hierarchyOrder === undefined || dtwin.hierarchyOrder >= _vm.maxHierarchyOrder - 1 ? _c(VHover, [_c(VSheet, {
      class: `${dtwin.class ? dtwin.class : ''} mb-4`,
      style: 'cursor: pointer;' + (dtwin.isChild ? 'opacity: 0.7' : ''),
      attrs: {
        "color": dtwin.class ? _vm.color : null
      },
      on: {
        "click": function ($event) {
          return _vm.selectDigitalTwin(dtwin);
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding": "20px"
      }
    }, [_c(VIcon, {
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "size": "28",
        "left": "",
        "color": dtwin.class ? 'white' : null
      }
    }, [_vm._v("\n                " + _vm._s(_vm.getTwinTreeIcon(dtwin)) + "\n              ")]), _c('div', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(dtwin.title))])], 1)])], 1) : _vm._e()], 1);
  }), _vm.selectedTwin && _vm.selectedTwin.children && _vm.selectedTwin.children.length < _vm.selectedTwin.childCount ? _c(VBtn, {
    staticClass: "v-btn-x mb-6",
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        return _vm.fetchChildren(_vm.selectedTwin.id, _vm.selectedTwin.children.length);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.loadMore')) + "\n      ")]) : _vm._e()], 2), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_vm.selectedTwin ? [_c(VRow, {
    staticClass: "ml-2 mr-2"
  }, [_c(VCol, {
    class: 'pt-0' + (_vm.$vuetify.breakpoint.xsOnly ? ' pb-0' : ''),
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', {
    staticClass: "mt-0 pt-1",
    staticStyle: {
      "margin-bottom": "14px",
      "cursor": "pointer"
    },
    on: {
      "click": function ($event) {
        return _vm.goToTwin(_vm.selectedTwin.id);
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedTwin.title) + "\n              "), _c(VIcon, {
    staticClass: "ml-2 mb-1",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "color": _vm.color,
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.goToTwin(_vm.selectedTwin.id);
      }
    }
  }, [_vm._v("\n                fal fa-external-link\n              ")])], 1), _vm.selectedTwin.data && _vm.selectedTwin.data.description ? [!_vm.$vuetify.breakpoint.xsOnly ? _c('span', [_vm._v("\n                " + _vm._s(_vm.selectedTwin.data.description) + "\n              ")]) : _vm._e()] : _vm._e()], 2)], 1), _c(VRow, {
    staticClass: "ml-2 mr-2"
  }, [_vm._l(_vm.aggregatedDTwinStates, function (state, stateIndex) {
    return _c(VCol, {
      key: stateIndex,
      class: _vm.$vuetify.breakpoint.xsOnly ? 'px-1 py-1' : '',
      attrs: {
        "cols": "6",
        "sm": "4",
        "lg": "4"
      }
    }, [_c('is-fm-building-mgmt-tiles', {
      attrs: {
        "state": state
      }
    })], 1);
  }), _vm.nonAggregatedDTwinStates.length > 0 ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VDataTable, {
    attrs: {
      "headers": _vm.statesTableHeaders,
      "items": _vm.nonAggregatedDTwinStates,
      "footer-props": _vm.statesTableFooterProps,
      "options": _vm.statesTableOptions,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.statesTableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.properties.faIcon",
      fn: function ({
        item
      }) {
        return [item.properties.faIcon ? _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(item.properties.faIcon))]) : _vm._e()];
      }
    }, {
      key: "item.stateTime",
      fn: function ({
        item
      }) {
        return [_c('span', {
          attrs: {
            "title": _vm.localizeDate(item.stateTime)
          }
        }, [_vm._v(_vm._s(_vm.relativeTime(item.stateTime)))])];
      }
    }, {
      key: "footer.page-text",
      fn: function (props) {
        return [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.lines')) + " " + _vm._s(props.pageStart) + " - " + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n                " + _vm._s(props.itemsLength) + "\n              ")];
      }
    }], null, false, 3634216426)
  })], 1) : _vm._e()], 2)] : _vm._e()], 2)], 1), _c('br'), _c('br')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };